// faq — en. FAQ page chrome. The Q&A bodies themselves live under faq1q..faq8a.

export default {
  faqHeroA: 'Frequently Asked',
  faqHeroB: 'Questions',
  faqSearchPlaceholder: 'Search questions...',
  faqCatAll: 'All Topics',
  faqCatAccount: 'Account',
  faqCatBuying: 'Buying',
  faqCatSelling: 'Selling',
  faqCatPayments: 'Payments',
  faqCatDelivery: 'Delivery',
  faqNoMatch: 'No questions match your search.',
  faqStillTitle: 'Still Have Questions?',
  faqStillDesc: 'Our support team is here to help you with anything you need.',
  faqContactSupport: 'Contact Support',
  faqCtaTitle: "Can't find what you're looking for?",
  faqCtaDesc: 'Our friendly team is ready to answer any questions you have about AllThings.',
  faqPhoneLabel: (n) => `Phone ${n}`,
  faqSupportHours: 'Support Hours',
};